import type { AnyObject } from '@naturalcycles/js-lib/types'
import type { ReactNode } from 'react'
import React from 'react'

interface Props {
  data: AnyObject
}

export function StructuredData(props: Props): ReactNode {
  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: ok
      dangerouslySetInnerHTML={{ __html: JSON.stringify(props.data) }}
    />
  )
}
